import { useMutation } from '@tanstack/react-query';
import { useToast } from 'app-context/toasterContext/ToastContext';
import axios from 'axios';
import { API_URL } from 'constants';
import { cleanToken } from 'utils';

const deleteData = async (url, data = null, requiresAuth = true) => {
  const headers = {
    ...(requiresAuth &&
      localStorage.getItem('token') && {
        Authorization: `Bearer ${cleanToken(localStorage.getItem('token'))}`,
      }),
    'Content-Type': 'application/json',
  };

  try {
    const response = await axios({
      method: 'delete',
      url: `${API_URL}${url}`,
      data,
      headers,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const useDelete = (options = {}) => {
  const toast = useToast();
  return useMutation({
    mutationFn: async ({ data = null, requiresAuth = true, url }) =>
      deleteData(url, data, requiresAuth),
    onSuccess: () => {
      if (options.onSuccessToast) {
        toast.open(options.onSuccessToast, 'add');
      }
    },
    onError: () => {
      if (options.onErrorToast) {
        toast.open(options.onErrorToast, true);
      } else {
        toast.open('Something went wrong', true);
      }
    },
    ...options,
  });
};
